import http from '@/utils/http.js'

const baseUrl = process.env.VUE_APP_REQUEST_BASE_URL + process.env.VUE_APP_REQUEST_USER_CENTER // 代理关键字

// 登录
const login = (data) => {
    return http.post(`${baseUrl}/umsMember/login`, data)
}

// 注册
const register = (data) => {
    return http.post(`${baseUrl}/umsMember/register`, data)
}

// 获得用户信息
const getUserInfo = (data) => {
    return http.get(`${baseUrl}/umsMember/auth/selectUserInfo`, data)
}

// 检查用户是否为空
const checkUserName = (data) => {
    return http.get(`${baseUrl}/umsMember/selectUserName`, data)
}

// 用户修改密码
const updatePassword = (data) => {
    return http.post(`${baseUrl}/umsMember/updatePassword`, data)
}

// 激活用户
const updateUserStatus = (data) => {
    return http.post(`${baseUrl}/umsMember/updateStatus`, data)
}

// 修改用户信息
const updateUserInfoById = (data) => {
    return http.post(`${baseUrl}/umsMember/auth/updateUserInfoById`, data)
}

// 官网 -- 联系我们
const contactUs = (data) => {
    return http.post(`${baseUrl}/umsMemberContact/contactUs`, data)
}

// 绑定shopify
const bindShopify = (data) => {
    return http.get(`${baseUrl}/umsMember/bindShopify`, data)
}

// 获得所有国家
const getAllCountrys = (data) => {
    return http.get(`${baseUrl}/umsCountry/selectCountry`, data)
}

// 获得所有州
const getAllProvinces = (data) => {
    return http.get(`${baseUrl}/umsState/selectState`, data)
}

// 选择收货地址
const getAddressList = (data) => {
    return http.get(`${baseUrl}/umsAddress/auth/selectAddressById`, data)
}

// 增加地址
const insertAddress = (data) => {
    return http.post(`${baseUrl}/umsAddress/auth/insertAddress`, data)
}

// 更新地址
const updateAddress = (data) => {
    return http.post(`${baseUrl}/umsAddress/auth/updateAddress`, data)
}

// 删除地址
const deleteAddress = (data) => {
    return http.post(`${baseUrl}/umsAddress/auth/deleteAddress`, data)
}

export default {
    login,
    register,
    getUserInfo,
    checkUserName,
    updatePassword,
    updateUserStatus,
    contactUs,
    updateUserInfoById,
    bindShopify,
    getAllCountrys,
    getAllProvinces,
    getAddressList,
    insertAddress,
    deleteAddress,
    updateAddress
}
